module.exports = __webpack_public_path__ + "img/excel.420f0666.svg";